import { render, staticRenderFns } from "./PedidoCard.vue?vue&type=template&id=197665ef"
import script from "./PedidoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports